import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function PassCryptLanding() {
  const { language } = useLanguage();

  return (
    <>
      <Header />
      <main className="main-content">
        <div className="container product-landing passcrypt-landing">
          <div className="section-header">
            <span className="section-badge">{translate("passcryptBadge", language)}</span>
            <h1 className="product-title passcrypt-title landing-product-title">
              <span>
                <span className="passcrypt-title-text">PassCrypt</span>
                <span className="passcrypt-title-copyright">©</span>
              </span>
            </h1>
            <p className="section-description landing-description">
              {translate("passcryptDescLong", language)}
            </p>
          </div>
          <div className="landing-cta">
            <a
              href={`mailto:support@ygalaad.com?subject=${encodeURIComponent(
                translate("passcryptTitle", language) +
                  " - " +
                  (language === "fr" ? "Contact" : "Contact")
              )}`}
              className="landing-link"
            >
              {translate("contactSupport", language)}
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default PassCryptLanding;
